T.EveryPay = Class(
    /**
     * @lends {T.EveryPay#}
     */
    {
        paymentId: null,
        onInit: D.doNothing,
        onError: D.doNothing,
        onChange: D.doNothing,

        everyPayPaymentMethods: null,
        countries: [],
        currentCountry: null,
        groupedOpenBankingMethods: {},
        currentPaymentMethod: null,

        isReady: false,

        __construct(par) {
            par = par || {};
            this.paymentId = par.paymentId;
            this.onInit = par.onInit || D.doNothing;
            this.onError = par.onError || D.doNothing;
            this.onChange = par.onChange || D.doNothing;

            this.node = mkE({
                tag: 'div',
                id: 'every-pay'
            });

            this._loadData(par.apiCall || null);
        },

        draw() {
            this._drawPaymentMethods();
        },

        _loadData(apiCall) {
            this._mGetEveryPayPaymentMethods = new DR.services.GetEveryPayPaymentMethods();
            this._mGetEveryPayPaymentMethods.onLoad = this._onEveryPayPaymentMethods;
            this._mGetEveryPayPaymentMethods.onError = this._onEveryPayPaymentMethodsError;
            if (apiCall) {
                apiCall.addMethod(this._mGetEveryPayPaymentMethods);
            } else {
                this._mGetEveryPayPaymentMethods.call();
            }
        },

        _onEveryPayPaymentMethods() {
            this.everyPayPaymentMethods = this._mGetEveryPayPaymentMethods.re;
            this.countries = this.everyPayPaymentMethods.openBanking.map(x => x.country);
            this.countries.forEach(country => {
                let countryData = this.everyPayPaymentMethods.openBanking.filter(x => x.country === country)[0];
                if (!countryData) {
                    return;
                }
                this.groupedOpenBankingMethods[country] = countryData.paymentMethods
                    .map(x => new T.EveryPay.PaymentMethod(x, this._onSelectPaymentMethod));
            });
        },

        _onEveryPayPaymentMethodsError() {
            this.onError();
        },

        _drawPaymentMethods() {
            if (this.everyPayPaymentMethods.card.length) {
              this._drawCardMethods();
            }
            if (this.countries.length) {
                this._drawOpenBankingMethods();
            }
            this._rulesContainer = mkE({
                tag: 'div',
                className: 'every-pay-rules',
                els: [
                    this._rulesCheckbox = new T.Form.CheckBox({
                        caption: mkE({
                            tag: 'a',
                            className: 'every-pay-rules-link',
                            href: D.url('terms'),
                            text: D.Lang.get('profile.team.purchase.payment_terms_text'),
                            attr: {
                                target: '_blank'
                            }
                        }),
                        onChange: this._onRulesChange
                    })
                ]
            }).append(this.node);
            this.isReady = true;
            this.onInit();
        },

        _onSelectPaymentMethod(paymentMethod) {
            if (this.currentPaymentMethod) {
                this.currentPaymentMethod.setActive(false);
            }
            this.currentPaymentMethod = paymentMethod;
            if (this.currentPaymentMethod) {
                this.currentPaymentMethod.setActive(true);
            }
            this.onChange();
        },

        _detectCountry() {
            if (this.countries.includes(D.LANG)) {
                this.currentCountry = D.LANG;
                return;
            }
            if (D.LANG === 'et' && this.countries.includes('ee')) {
                this.currentCountry = 'ee';
                return;
            }
            this.currentCountry = 'lv';
        },

        _drawCountrySelectCaption(country) {
            return mkE({
                tag: 'div',
                className: 'every-pay-country-select-caption',
                els: [
                    [
                        country.toUpperCase(),
                        {
                            tag: 'img',
                            src: `/assets/images/every-pay/flags/${country}.svg`
                        }
                    ]
                ]
            });
        },

        _onChangeCountry() {
            this._onSelectPaymentMethod(null);
            this.currentCountry = this._countrySelect.value();
            this._drawOpenBankingMethodItems();
        },

        _onRulesChange() {
            this.onChange();
        },

        _drawOpenBankingMethods() {
            this._detectCountry();
            let countryOptions = [];
            this.countries.forEach(country => {
                countryOptions.push({
                    value: country,
                    caption: D.Lang.get(`iso.countries.${country}`)
                })
            });
            this._openBankingNode = mkE({
                tag: 'div',
                className: 'every-pay-method-type every-pay-payment-method-type-open-banking',
                els: [
                    {
                        tag: 'div',
                        className: 'every-pay-method-type-header',
                        els: [
                            {
                              tag: 'div',
                              className: 'every-pay-method-type-name',
                              text: D.Lang.get('profile.team.purchase.open_banking')
                            },
                            {
                                tag: 'div',
                                className: 'every-pay-method-type-line',
                            }
                        ]
                    },
                    {
                      tag: 'div',
                      className: 'every-pay-method-type-selector',
                      els: [
                        this._countrySelect = new T.Form.Select({
                          border: true,
                          small: true,
                          onChange: this._onChangeCountry,
                          value: this.currentCountry,
                          options: countryOptions,
                          drawCaption: this._drawCountrySelectCaption
                        })
                      ]
                    },
                    this._openBankingItems = mkE({
                        tag: 'div',
                        className: 'every-pay-method-type-items'
                    })
                ]
            }).append(this.node);
            this._drawOpenBankingMethodItems();
        },

        _drawOpenBankingMethodItems() {
            clearNode(this._openBankingItems);
            this.groupedOpenBankingMethods[this.currentCountry].forEach(method => {
                method.append(this._openBankingItems);
            });
        },

        _drawCardMethods() {
            mkE({
                tag: 'div',
                className: 'every-pay-method-type every-pay-payment-method-type-card',
                els: [
                    {
                      tag: 'div',
                      className: 'every-pay-method-type-header',
                      els: [
                        {
                          tag: 'div',
                          className: 'every-pay-method-type-name',
                          text: D.Lang.get('profile.team.purchase.cards')
                        },
                        {
                          tag: 'div',
                          className: 'every-pay-method-type-line',
                        }
                      ]
                    },
                    this._cardItems = mkE({
                        tag: 'div',
                        className: 'every-pay-method-type-items'
                    })
                ]
            }).append(this.node);
            this.everyPayPaymentMethods.card.forEach(method => {
                new T.EveryPay.PaymentMethod(method, this._onSelectPaymentMethod).append(this._cardItems);
            });
            this.drawApplePayPaymentMethod();
            this.drawGooglePayPaymentMethod();
        },

        drawApplePayPaymentMethod() {
            if (!([8, 63373].includes(D.ID) || (D.me.email && D.me.email.endsWith('@roadgames.com')))) {
                return;
            }
            if (!window.ApplePaySession || !ApplePaySession.canMakePayments()) {
                return;
            }
            D.onApplePay(() => {
                this._applePayButton = new T.EveryPay.PaymentMethodApplePay(this._onSelectPaymentMethod)
                    .prepend(this._cardItems);
            });
        },

        drawGooglePayPaymentMethod() {
            if (!([8, 63373].includes(D.ID) || (D.me.email && D.me.email.endsWith('@roadgames.com')))) {
                return;
            }
            if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
                return;
            }
            D.onEveryPayGooglePayClient(() => {
                this._googlePayButton = new T.EveryPay.PaymentMethodGooglePay(this._onSelectPaymentMethod);
                if (this._applePayButton) {
                    D.insertAfter(this._googlePayButton.node, this._applePayButton.node);
                } else {
                    this._googlePayButton.prepend(this._cardItems);
                }
            });
        },

        hasSelectedPaymentMethod() {
            return !!this.currentPaymentMethod;
        },

        hasAgreedToRules() {
            return !!this._rulesCheckbox.value();
        },

        getPaymentLink(paymentId, onSuccess, onFailure) {
            this._mGetEveryPayData = new DR.services.GetEveryPayData();
            this._mGetEveryPayData.paymentId = paymentId;
            if (this.currentPaymentMethod.data.source === 'apple-pay') {
                this._mGetEveryPayData.selectedPaymentMethod = 'apple-pay';
            } else if (this.currentPaymentMethod.data.source === 'google-pay') {
                this._mGetEveryPayData.selectedPaymentMethod = 'google-pay';
            }
            this._mGetEveryPayData.onLoad = () => {
                if (this.currentPaymentMethod.data.source === 'apple-pay') {
                    this.startApplePayPayment(this._mGetEveryPayData.re, () => {
                        onSuccess(null);
                    });
                    return;
                } else if (this.currentPaymentMethod.data.source === 'google-pay') {

                    this.startGooglePayPayment(this._mGetEveryPayData.re, () => {
                        onSuccess(null);
                    });
                    return;
                }
                onSuccess(this._mGetEveryPayData.re.paymentMethods.find(m => {
                    return m.source === this.currentPaymentMethod.data.source;
                }).link);
            };
            this._mGetEveryPayData.onError = () => {
                onError();
            };
            this._mGetEveryPayData.call();
        },

        getRulesCheckbox() {
            return this._rulesCheckbox;
        },

        resetRulesCheckbox() {
            this._rulesCheckbox.append(this._rulesContainer);
        },

        hideNodes() {
            this._rulesContainer.style.display = 'none';
            this._rulesCheckbox.node.style.display = 'none';
            this.node.style.display = 'none';
        },

        showNodes() {
            this._rulesContainer.style.display = '';
            this._rulesCheckbox.node.style.display = '';
            this.node.style.display = '';
        },

        /**
         *
         * @param {DR.services.struct.EveryPayData} data
         * @param callback
         */
        startApplePayPayment(data, callback) {
            D.onEveryPayApplePayClient(() => {
                this._applePayClient = ApplePayClient.initialize({
                    access_token: data.mobileToken,
                    api_username: data.apiUsername,
                    merchant_id: data.applePayMerchantIdentifier,
                    account_name: data.accountName,
                });
                this._applePayClient.createApplePayPayment({
                    payment_reference: data.paymentReference,
                    country_code: data.descriptorCountry,
                    currency_code: data.currency,
                    payment_link: data.paymentLink,
                    total: {
                        label: data.label,
                        amount: data.amount / 100
                    }
                });
                if (callback) {
                    callback();
                }
            });
        },

        /**
         *
         * @param {DR.services.struct.EveryPayData} data
         * @param callback
         */
        startGooglePayPayment(data, callback) {
            if (!this._googlePayClient) {
                this._googlePayClient = GooglePayClient.initialize({
                    testEnv: D.DEV
                });
            }
            const googleClientData = {
                access_token: data.mobileToken,
                api_username: data.apiUsername,
                account_name: data.accountName,
                payment_reference: data.paymentReference,
                country_code: data.descriptorCountry,
                currency_code: data.currency,
                payment_link: data.paymentLink,
                amount: `${data.amount / 100}`,
            }
            this._googlePayClient.configure(googleClientData);
            this._googlePayClient.createGooglePayPayment();
            if (callback) {
                callback();
            }
        }
    },
    mkE.Base
);

T.EveryPay.PaymentMethod = Class(
    /**
     * @lends {T.EveryPay.PaymentMethod#}
     */
    {
        data: null,
        onSelect: D.doNothing,

        /**
         *
         * @param {DR.services.struct.EveryPayPaymentMethod} data
         * @param {Function} onSelect
         */
        __construct(data, onSelect) {
            this.data = data;
            this.onSelect = onSelect || D.doNothing;

            this.node = mkE({
                tag: 'div',
                className: 'every-pay-method',
                els: [
                    this._inner = mkE({
                        tag: 'div',
                        className: 'inner',
                        els: [
                            {
                                tag: 'img',
                                alt: data.name,
                                src: data.logoLink
                            }
                        ]
                    })
                ],
                onclick: () => {
                    this.onSelect(this)
                }
            });
        },

        setActive(isActive) {
            if (isActive) {
                addClassName(this.node, 'active');
            } else {
                removeClassName(this.node, 'active');
            }
        }
    },
    mkE.Base
);

T.EveryPay.PaymentMethodApplePay = Class(
    /**
     * @lends {T.EveryPay.PaymentMethodApplePay#}
     */
    {
        data: null,
        onSelect: D.doNothing,

        /**
         *
         * @param {Function} onSelect
         */
        __construct(onSelect) {
            this.data = {
                source: 'apple-pay'
            };
            this.onSelect = onSelect || D.doNothing;

            this.node = mkE({
                tag: 'div',
                className: 'every-pay-method',
                els: [
                    this._inner = mkE({
                        tag: 'div',
                        className: 'inner',
                        els: [
                            {
                                tag: 'apple-pay-button',
                                attr: {
                                    buttonstyle: 'white',
                                    type: 'plain',
                                    locale: 'en-US'
                                },
                                onclick: () => {
                                    this.onSelect(this)
                                }
                            }
                        ]
                    })
                ],
                onclick: () => {
                    this.onSelect(this)
                }
            });
        },

        setActive(isActive) {
            if (isActive) {
                addClassName(this.node, 'active');
            } else {
                removeClassName(this.node, 'active');
            }
        }
    },
    mkE.Base
);

T.EveryPay.PaymentMethodGooglePay = Class(
    /**
     * @lends {T.EveryPay.PaymentMethodGooglePay#}
     */
    {
        data: null,
        onSelect: D.doNothing,

        /**
         *
         * @param {Function} onSelect
         */
        __construct(onSelect) {
            this.data = {
                name: 'Google Pay',
                source: 'google-pay',
                logoLink: '/assets/images/every-pay/payment-methods/google-pay.png'
            };
            this.onSelect = onSelect || D.doNothing;

            this.node = mkE({
                tag: 'div',
                className: 'every-pay-method every-pay-method--google-pay',
                els: [
                    this._inner = mkE({
                        tag: 'div',
                        className: 'inner',
                        els: [
                            {
                                tag: 'img',
                                alt: this.data.name,
                                src: this.data.logoLink
                            }
                        ]
                    })
                ],
                onclick: () => {
                    this.onSelect(this)
                }
            });
        },

        setActive(isActive) {
            if (isActive) {
                addClassName(this.node, 'active');
            } else {
                removeClassName(this.node, 'active');
            }
        }
    },
    mkE.Base
);